import * as React from 'react'

import { useToggle } from '@factorialco/deprecated-design-system'

import ExplotableItem from 'modules/core/components/Explotable/List/Item'

import type { ConditionsGroup } from '../types'
import { Conditions } from './Conditions'

export interface Props {
  title: string
  items: ConditionsGroup[] | JSX.Element[]
  extensionFeatureHasConditions: boolean
  renderHeader: (title: string) => React.ReactElement
}

const ConditionGroup = ({ title, items, renderHeader, extensionFeatureHasConditions }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <ExplotableItem
      expandIcon="plus-minus"
      headerBorders={false}
      opened={open}
      renderHeader={() => renderHeader(title)}
      size="small"
      toggle={toggle(!open)}
      scrollLimited={false}
    >
      <Conditions items={items} extensionFeatureHasConditions={extensionFeatureHasConditions} />
    </ExplotableItem>
  )
}

export default ConditionGroup
